module.exports = __webpack_public_path__ + "img/opengov.b3a537cf.png";